module.exports = __webpack_public_path__ + "img/zhifutu.a9d1240c.png";